
import { useLocation } from "react-router-dom";
import {  useState } from "react";
const VeloAPIService = {
    checkAndApplyOfferFull(code = "") {
        const options = {
            method: "GET",
            headers: {
                "X-API-KEY": process.env.REACT_APP_VELOSURE_API_KEY,
                "content-type": "application/json",
            },
        };
        return fetch(`${process.env.REACT_APP_VELOSURE_API_URL}/api/Offers/GetCurrentOffer?code=${code}`, options)
            .then((response) => { return response.json() })
           
    },
    checkAndApplyOffer() {
        const options = {
            method: "GET",
            headers: {
                "X-API-KEY": process.env.REACT_APP_VELOSURE_API_KEY,
                "content-type": "application/json",
            },
        };

        return fetch(`${process.env.REACT_APP_VELOSURE_API_URL}/api/Offers/GetCurrentOffer`, options)
            .then((response) => { return response.json() })
            
    },
    async AddTransactorNotes(request) {
        const options = {
            method: "POST",
            headers: {
                "X-API-KEY": process.env.REACT_APP_VELOSURE_API_KEY,
                "content-type": "application/json",
            },
            body: JSON.stringify(request),
        };

        const response = await fetch(`${process.env.REACT_APP_VELOSURE_API_URL}/api/TransactorNotes/AddNote`, options);
        return await response.json();
    }
}

export default VeloAPIService;